export const sortData = (data, sortOrder, sortedBy) => {
  const sortedData = [...data].sort((a, b) => {
    const parseDate = (str) => {
      if (!str) return new Date(0);
      const [day, month, year] = str.split("/");
      return new Date(`${year}-${month}-${day}`);
    };
    return sortOrder === "asc"
      ? parseDate(a[sortedBy]) - parseDate(b[sortedBy])
      : parseDate(b[sortedBy]) - parseDate(a[sortedBy]);
  });
  return sortedData;
};

export const sortByDisplayOrder = (items = []) => {
  return [...items].sort(
    (a, b) => Number(a.display_order) - Number(b.display_order)
  );
};

export const sortPricelistHierarchy = (subPricelists = []) => {
  const sortedSubPricelists = sortByDisplayOrder(subPricelists).map(
    (subPricelist) => ({
      ...subPricelist,

      services: sortByDisplayOrder(subPricelist.services || []).map(
        (service) => ({
          ...service,

          variants: sortByDisplayOrder(service.variants || []),
        })
      ),
    })
  );

  return sortedSubPricelists;
};

export const sortFullPricelistHierarchy = (pricelists = []) => {
  return sortByDisplayOrder(pricelists).map((pricelist) => ({
    ...pricelist,
    sub_pricelists: sortByDisplayOrder(pricelist.sub_pricelists || []).map(
      (sub) => ({
        ...sub,
        services: sortByDisplayOrder(sub.services || []).map((service) => ({
          ...service,
          variants: sortByDisplayOrder(service.variants || []),
        })),
      })
    ),
  }));
};

export const sortCategoriesWithSubcategories = (categories = []) => {
  const sortedMain = sortByDisplayOrder(categories);

  return sortedMain.map((cat) => ({
    ...cat,
    sub_categories: sortByDisplayOrder(cat.sub_categories || []),
  }));
};
